export default "__VITE_ASSET__W2eLOSv3__"